function init() {
    window.addEventListener("load", (event) => { 
        onScrollRemoveArrowFade();
    })
}

function onScrollRemoveArrowFade() { 
  window.addEventListener('scroll', () => {

    if (window.scrollY >= 350) {
      const element = document.querySelector('.people-hero > .wp-block-group') || document.querySelector('.single-case-study .is-style-group-hero > .wp-block-group');
      if (element) {
        element.classList.add('remove-arrow');
      }
    }
    if (window.scrollY <= 349) {
        const element = document.querySelector('.people-hero > .wp-block-group') || document.querySelector('.single-case-study .is-style-group-hero > .wp-block-group');
        if (element) {
          element.classList.remove('remove-arrow');
        }
      }
  });
}

export { init as default }
